import React, {useContext } from 'react'
import {Box, Typography, Button } from '@material-ui/core';
import { CartContext } from '../CartContext/CartContext';
import CartTable from '../CartTable.jsx/CartTable';
import { Link } from 'react-router-dom';
// import Return from '../utils/Return';


export default function Cart() {

	const cartContext = useContext(CartContext);
	const {cart, total, removeFromCart, updateCartQuantity, ivaTotal}= cartContext;
	const totalUnits = cart.reduce((sum, product) => sum + (Number(product.qty) || 0), 0);
 
  return (
    <>
    <Typography variant={"h5"}>Revisá tu pedido</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
      {totalUnits === 1 ? '1 unidad' : `${totalUnits} unidades`} en {cart.length === 1 ? '1 producto' : `${cart.length} productos`}
    </Typography>
      {cart.length > 0 ? (
        <Box
        // sx={{fontSize: 20, display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: "center", margin: "0px", flexWrap:'wrap', width:"100%"}} >
        sx={{fontSize: 20, display: "flex", flexDirection:"column", justifyContent: "space-between", alignItems: "center", margin: "0px", flexWrap:'wrap', width:"100%"}} >
          <CartTable
            cart={cart}
            removeFromCart={removeFromCart}
            updateCartQuantity={updateCartQuantity}
            total={total}
            ivaTotal={ivaTotal}
          />
        </Box>

      ) : (
        <Box sx={{fontSize: 12, display: "flex", flexDirection: "column", justifyContent: "space-evenly", alignItems: "center", margin: "50px",}} >
          <Typography sx={{fontSize: 20, display: "flex", flexDirection: "column", justifyContent: "space-evenly", alignItems: "center", margin: "10px",}} >
            Tu pedido está vacío
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 2 }}>
            Buscá productos en el catálogo y agregalos para preparar tu pedido.
          </Typography>
          <Link to={`/`} style={{ textDecoration:"none", color:"inherit"}}>
			    	<Button size="small" variant="contained" color="primary"  sx={{ fontSize: 12, width:"100%",  }}
			    >Ir al catálogo</Button>
			    </Link>	
            
        </Box>
      )}
    </>
  );
}
